module.exports = __webpack_public_path__ + "img/11.45d090aa.svg";